import { useEffect, useState, lazy, Suspense } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Preloader } from "@/components/Preloader";
import { Cursor } from "@/components/Cursor";
import { Navbar } from "@/components/Navbar";
import Hero from "@/sections/Hero";

const About = lazy(() => import("@/sections/About"));
const Skills = lazy(() => import("@/sections/Skills"));
const Projects = lazy(() => import("@/sections/Projects"));
const Certificates = lazy(() => import("@/sections/Certificates"));
const Contact = lazy(() => import("@/sections/Contact"));

function App() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-[#0D0D0D]">
      <div className="noise-overlay" />
      <Cursor />
      {!loaded && <Preloader onDone={() => setLoaded(true)} />}
      <Navbar />
      <main>
        <Hero />
        <Suspense fallback={<div className="min-h-screen" />}>
          <About />
          <Skills />
          <Projects />
          <Certificates />
          <Contact />
        </Suspense>
      </main>
    </div>
  );
}

export default App;
